import * as React from "react";

import { SvgIconProps } from "@material-ui/core/SvgIcon";
import styled from "~/styled";

interface IProps {
  icon: React.ComponentType<SvgIconProps>;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  description_html?: string;
  onClickHandler: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

const ButtonWrapper = styled.div`
  display: inline-flex;
  width: 100%;
  flex-direction: column;
  padding: 30px 20px;
  border-radius: 3px;
  box-shadow: 0 0 0 1px rgb(16 22 26 / 15%), 0 0 0 rgb(16 22 26 / 0%),
    0 0 0 rgb(16 22 26 / 0%);
  transition: transform 200ms cubic-bezier(0.4, 1, 0.75, 0.9),
    box-shadow 200ms cubic-bezier(0.4, 1, 0.75, 0.9);

  &:hover {
    cursor: pointer;
    box-shadow: 0 0 0 1px rgb(16 22 26 / 10%), 0 2px 4px rgb(16 22 26 / 20%),
      0 8px 24px rgb(16 22 26 / 20%);
  }

  &:not(:last-child) {
    margin-right: 12px;
  }
`;

const IconTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  @media (max-width: 320px) {
    flex-direction: column;
  }
`;

const IconWrapper = styled.div`
  color: ${props => props.theme.brandColor.primary};
  margin-right: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Title = styled.h4`
  margin: 0 10px 0 0;
  color: ${props => props.theme.brandColor.primary};
  font-size: 18px;
  font-weight: 500;

  @media (max-width: 568px) {
    font-size: 16px;
  }

  @media (max-width: 375px) {
    font-size: 14px;
    text-align: center;
  }

  @media (max-width: 320px) {
    font-size: 12px;
    text-align: center;
  }
`;

const Description = styled.p`
  margin: 8px 0 0 0;
  text-align: center;

  @media (max-width: 568px) {
    font-size: 14px;
  }

  @media (max-width: 375px) {
    font-size: 12px;
  }

  @media (max-width: 320px) {
    font-size: 10px;
  }
`;

export default class Button extends React.Component<IProps> {
  public render() {
    const { icon: Icon, title, onClickHandler, description } = this.props;

    return (
      <ButtonWrapper onClick={onClickHandler}>
        <IconTitle>
          <IconWrapper>
            <Icon />
          </IconWrapper>

          <TitleWrapper>{title ? <Title>{title}</Title> : null}</TitleWrapper>
        </IconTitle>

        {description ? <Description>{description}</Description> : null}
      </ButtonWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomerSupport/Button.tsx